import { LoadingButton } from "@mui/lab";
import { Box, Button, Grid, Typography } from "@mui/material";
import { OrganizationUserContext } from "contexts/Organization";
import { SlideAnimationContext } from "contexts/SlideAnimation";
import { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import VideoEmbed from "components/VideoEmbed";
import { vaOnboardingNavigate } from "features/Auth/Onboarding/helper";
import { HIDE_VA_ONBOARDING_VIDEO } from "utils/localStorage";

interface Props {
  hasPaidForSupportCall?: boolean;
}

const VAVideo = ({ hasPaidForSupportCall }: Props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { currentOrg } = useContext(OrganizationUserContext);
  const slideContext = useContext(SlideAnimationContext);

  const handleBack = async () => {
    if (slideContext) {
      await slideContext.slideOutDown();
      slideContext.slideInDown();
    }
    navigate(
      `/${vaOnboardingNavigate(location.pathname, "back", undefined, false, hasPaidForSupportCall)}${location.search}`,
    );
  };

  const handleNext = async () => {
    if (slideContext) {
      await slideContext.slideOutUp();
      slideContext.slideInUp();
    }

    localStorage.setItem(
      `${HIDE_VA_ONBOARDING_VIDEO}-${currentOrg?.id}`,
      "true",
    );
    navigate(
      `/${vaOnboardingNavigate(location.pathname, "next")}${location.search}`,
    );
  };

  return (
    <>
      <Typography variant="h3" gutterBottom sx={{ textAlign: "center", mt: 0 }}>
        Watch the intro video below
      </Typography>
      <Typography
        variant="subtitle1"
        gutterBottom
        sx={{ textAlign: "center", mb: 3 }}
      >
        We cover important information and frequently asked questions, and have
        some immediate action items for you to complete
      </Typography>
      <VideoEmbed
        link="https://storage.googleapis.com/hatchways-crm.appspot.com/app-assets/new_introduction_video.mp4"
        eventName="VA Onboarding Flow - Introduction Video Clicked"
      />

      <Grid item xs="auto" container columnGap={1} sx={{ mt: 4 }}>
        <Grid item xs="auto">
          <Button onClick={handleBack} color="secondary" disableElevation>
            Back
          </Button>
        </Grid>
        <Grid item xs></Grid>
        <Grid item xs="auto">
          <LoadingButton
            disableElevation
            variant="contained"
            onClick={handleNext}
          >
            Next{" "}
            <Box
              sx={{ ml: 1 }}
              component="i"
              className="fa-solid fa-arrow-right"
            />
          </LoadingButton>
        </Grid>
      </Grid>
    </>
  );
};

export default VAVideo;
